"use strict";

var React = require("react");
module.exports = React.createElement(
  "svg",
  { viewBox: "0 0 48 48" },
  React.createElement("path", { d: "M40.327.908L17.57 6.805A2.066 2.066 0 0 0 16 8.742v23.712A8.553 8.553 0 0 0 13.235 32a12.307 12.307 0 0 0-4.744 1c-4.76 2-7.462 6.373-6.034 9.76.947 2.248 3.474 3.5 6.458 3.5a12.311 12.311 0 0 0 4.744-1C17.677 43.567 20 40.2 20 37.143V13.172l18-4.72v18A8.553 8.553 0 0 0 35.235 26a12.307 12.307 0 0 0-4.744 1c-4.76 2.005-7.462 6.376-6.034 9.763.947 2.248 3.474 3.5 6.458 3.5a12.311 12.311 0 0 0 4.744-1C39.677 37.567 42 34.2 42 31.143V2.156A1.348 1.348 0 0 0 40.327.908z" })
);

